import React from 'react'

interface ProjectIconProps {
  status: 'in_progress' | 'closed' | 'completed'
  className?: string
}

export const ProjectIcon: React.FC<ProjectIconProps> = ({ status, className = '' }) => {
  const getBackgroundColor = () => {
    switch (status) {
      case 'in_progress':
        return 'bg-[#f3fcfc]' // Light blue background for in progress
      case 'closed':
      case 'completed':
        return 'bg-[#fefdeb]' // Light yellow background for closed
      default:
        return 'bg-[#f9f5ff]' // Light purple default
    }
  }

  const getStrokeColor = () => {
    switch (status) {
      case 'in_progress':
        return '#229090' // Blue stroke for in progress
      case 'closed':
      case 'completed':
        return '#9e9705' // Yellow stroke for closed
      default:
        return '#7035c4' // Purple default
    }
  }

  return (
    <div className={`${getBackgroundColor()} w-12 h-12 rounded border border-gray-200 flex items-center justify-center overflow-hidden px-2 py-[9px] ${className}`}>
      {/* Folder Icon with RFP text overlay */}
      <div className="relative w-[51.542px] h-[49.428px]">
        {/* Base folder shape */}
        <svg 
          width="52" 
          height="50" 
          viewBox="0 0 52 50" 
          fill="none" 
          className="absolute inset-0"
        >
          {/* Folder back panel */}
          <path 
            d="M4 8C4 6.89543 4.89543 6 6 6H20L24 10H46C47.1046 10 48 10.8954 48 12V42C48 43.1046 47.1046 44 46 44H6C4.89543 44 4 43.1046 4 42V8Z" 
            fill="#f0f0f0"
            stroke={getStrokeColor()}
            strokeWidth="1"
          />
          {/* Folder front panel */}
          <path 
            d="M4 14C4 12.8954 4.89543 12 6 12H46C47.1046 12 48 12.8954 48 14V42C48 43.1046 47.1046 44 46 44H6C4.89543 44 4 43.1046 4 42V14Z" 
            fill="#ffffff"
            stroke={getStrokeColor()}
            strokeWidth="1"
          />
        </svg>
        
        {/* RFP text overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span 
            className="text-[10px] font-bold text-gray-600 mt-1"
            style={{ color: getStrokeColor() }}
          >
            RFP
          </span>
        </div>
      </div>
    </div>
  )
}

export default ProjectIcon